module.exports = __webpack_public_path__ + "img/bg.40e7fc01.jpg";